import { ResponseBase } from '@api/types';

export type UserRole = 'applicant' | 'agent' | 'usaceRegulator' | 'helpDesk' | 'externalAgency';

export type UserRoleInput = UserRole | string | null | undefined;

export const USER_ROLE_CAPABILITIES = [
  'createRequest',
  'editRequest',
  'signSubmitRequest',
  'withdrawRequest',
  'cancelRequest',
  'manageAccess',
  'viewDashboard',
  'viewDeveloperTab',
  'processHelpInquiry',
] as const;

export type UserRoleCapability = (typeof USER_ROLE_CAPABILITIES)[number];

export type UserRoleCapabilityInput = UserRoleCapability | string;

export type UserRoleCapabilityMap = Record<UserRoleCapability, boolean>;

export type GetUserRoleCapabilitiesResponseData = {
  role: UserRoleInput;
  capabilities: UserRoleCapabilityInput[];
};

export type GetUserRoleCapabilitiesResponse = ResponseBase & {
  data: GetUserRoleCapabilitiesResponseData | null;
};

export type GetUserRoleCapabilitiesQueryData = GetUserRoleCapabilitiesResponseData | null;
